import { Box, Button, Stack, Typography } from '@mui/material';
import { StorefrontOutlined } from '@mui/icons-material';
import { CARD_SX, SECTION_ICON_BOX_SX } from './accountOverview.utils';

export default function AccountOverviewIfoodCard({ navigate }) {
  return (
    <Box sx={{ ...CARD_SX, p: { xs: 2.5, md: 3 } }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} gap={2}>
        <Box sx={{ ...SECTION_ICON_BOX_SX, color: '#EA1D2C', background: 'rgba(234,29,44,.09)', borderColor: 'rgba(234,29,44,.16)' }}>
          <StorefrontOutlined sx={{ fontSize: 23 }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ color: '#0f172a', fontWeight: 800 }}>Integração iFood</Typography>
          <Typography variant="body2" sx={{ color: '#64748b', mt: 0.35 }}>
            Conecte suas lojas e acesse os recursos do AtendaBot, One Menu e FeedbackHero.
          </Typography>
        </Box>
        <Button
          variant="contained"
          onClick={() => navigate('/configuracoes/ifood')}
          sx={{
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 800,
            backgroundColor: '#EA1D2C',
            '&:hover': { backgroundColor: '#c91524' },
          }}
        >
          Abrir integração
        </Button>
      </Stack>
    </Box>
  );
}
